const timeStamps: { [key: string]: number } = {};
const stepTimes: { [key: string]: number } = {};

export const startTracking = (trackingId: string) => {
    timeStamps[trackingId] = Date.now();
};

export const startStepTracking = (trackingId: string, step: string | number) => {
    stepTimes[`${trackingId}_${step}`] = Date.now();
};

export const getTimeSpent = (trackingId: string, step: string | number): number => {
    const key = `${trackingId}_${step}`;
    return stepTimes[key] ? Date.now() - stepTimes[key] : 0;
};

export const getTotalTime = (trackingId: string): number =>
    timeStamps[trackingId] ? Date.now() - timeStamps[trackingId] : 0;

export const clearTracking = (trackingId: string) => {
    delete timeStamps[trackingId];
    Object.keys(stepTimes)
        .filter(key => key.startsWith(`${trackingId}_`))
        .forEach(key => {
            delete stepTimes[key];
        });
};
